/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }

  reactMessage(conversationId, messageId, emoji) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/react`,
      { emoji }
    );
  }

  sendSticker(conversationId, dataUrl) {
    return axios.post(
      `${this.url}/${conversationId}/messages/send_sticker`,
      { data_url: dataUrl }
    );
  }

  editMessageContent(conversationId, messageId, content) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/edit_content`,
      { content }
    );
  }

  deleteMessageForEveryone(conversationId, messageId) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/delete_for_everyone`
    );
  }

  favoriteMessage(conversationId, messageId, favorite) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/favorite`,
      { favorite }
    );
  }

  assignAgent({ conversationId, agentId, assigneeType }) {
    return axios.post(
      `${this.url}/${conversationId}/assignments`,
      {
        assignee_id: agentId,
        assignee_type: assigneeType || 'Agent',
      }
    );
  }

  moveConversation(conversationId, inboxId) {
    return axios.post(`${this.url}/${conversationId}/move`, { inbox_id: inboxId });
  }
}

export default new ConversationApi();
